<template>
  <!--在未绑定任何账号时，点击切换账号按钮调起这个提示弹窗-->
  <!--点击了切换账号之后，会丢失当前游客账号-->
  <Block
    type="tipsDialog"
    tagName="article"
    class="dialog-container tips-dialog"
  >
    <Block type="tipsDialogWrapper" class="tips-dialog-wrapper">
      <Title type="dialogTitle" class="dialog-title">
        {{ languages.tips.toUpperCase() }}
      </Title>
      <Content type="tipsContent" :class="['tips-content', { 'text-left': textLeft, 'pre-wrap': preWrap, 'is-scroll': isScroll }]">{{ tipContent }}</Content>
      <Block type="dialogBtnDocker" tagName="footer" class="account-ops">
        <Button
          type="shortCancel"
          class="cencel-account btn j-cancle-tip-btn"
          @click="sendCancelEvt"
        >
          {{ languages.cancel.toUpperCase() }}
        </Button>
        <Button
          type="shortConfirm"
          class="swtich-account btn j-sure-tip-btn"
          @click="sendConfirmEvt"
        >
          {{ languages.confirm.toUpperCase() }}
        </Button>
      </Block>
    </Block>
    <Button
      type="closeBtn"
      class="close-btn j-close-tip-btn"
      @click="closeDialog"
    ></Button>
  </Block>
</template>
<script>
import { EventBus } from '../utiles';
import { HIDE_DIALOG } from '../store/dialog';
export const CLOSE_EVENT = 'closetTimeEvent';
export default {
  computed: {
    cancel() {
      return this.$store.state.cancel;
    },
    confirm() {
      return this.$store.state.confirm;
    },
    textLeft() {
      return this.$store.state.dialog.textLeft;
    },
    preWrap() {
      return this.$store.state.dialog.preWrap;
    },
    isScroll() {
      return this.$store.state.dialog.isScroll;
    },
    tipContent() {
      return this.$store.state.dialog.tipContent;
    },
    tipsConfirmCallbackType() {
      return this.$store.state.dialog.tipsConfirmCallbackType;
    },
    tipsCancelCallbackType() {
      return this.$store.state.dialog.tipsCancelCallback;
    },
    tipsCloseCallBackType() {
      return this.$store.state.dialog.tipsCloseCallBack;
    },
    languages() {
      return this.$store.state.passport.languages;
    },
  },
  methods: {
    closeDialog() {
      this.$store.dispatch(HIDE_DIALOG);
    },
    sendCloseEvt() {
      this.closeDialog();
      if (this.tipsCloseCallBackType) {
        setTimeout(() => {
          EventBus.$emit(CLOSE_EVENT, this.tipsCancelCallbackType);
        }, 500);
      }
    },

    sendCancelEvt() {
      this.closeDialog();
      if (this.tipsCancelCallbackType) {
        setTimeout(() => {
          EventBus.$emit(CLOSE_EVENT, this.tipsCloseCallBackType);
        }, 500);
      }
    },
    sendConfirmEvt() {
      this.closeDialog();
      if (this.tipsConfirmCallbackType) {
        setTimeout(() => {
          EventBus.$emit(CLOSE_EVENT, this.tipsConfirmCallbackType);
        }, 500);
      }
    },
  },
};
</script>
<style scoped>
.text-left {
  text-align: left;
}
.pre-wrap {
  white-space: pre-wrap;
}
.is-scroll {
  height: 500px;
  overflow: scroll;
}
</style>